import { Model } from 'modules/core/lib/mobx-rest'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import type { PolicyTarget } from 'modules/permissions/store/collections/policyAuthorizations'

export interface Attributes {
  id: string
  company_id: string
  name: string
  description: string
  legal_entities_ids: string[]
  supervisors_ids: string[]
  archived: boolean
  competencies_ids: string[]
}

class JobRole extends Model<Attributes> implements PolicyTarget {
  static urlRoot() {
    return '/job_catalog/roles'
  }

  static importUrl() {
    return '/job_catalog/imports'
  }

  get policyTargetClass(): string {
    return '::JobCatalog::Role'
  }

  isRoleInLegalEntity(legalEntity: LegalEntity): boolean {
    return this.attributes.legal_entities_ids.includes(legalEntity.id)
  }

  isRoleInLegalEntityId(id: string): boolean {
    return this.attributes.legal_entities_ids.includes(id)
  }

  get isArchived(): boolean {
    return this.attributes.archived
  }

  get isActive(): boolean {
    return !this.attributes.archived
  }
}

export default JobRole
